const state = {
  total_count: 0,
  mentor_list: [{
    slug: '',
    username: '',
    get_full_name: '',
    gender: '',
    is_active: 0,
    photo_url: '',
    old_hadian: true,
    get_educ_display: '',
    is_mentor_of_local_platoon: false,
    is_mentor_of_city_platoon: false,
    is_mentor_of_province_platoon: false,
    is_mentor_of_nation_platoon: false,
  }],
}

const getters = {
  MentorList: state => state.mentor_list,
  MentorTotalCount: state => state.total_count,
}

const mutations = {
  setMentorList(state, payload) { state.mentor_list = payload.list; state.total_count = payload.total_count },
  setMentorListPush(state, payload) { state.mentor_list = state.mentor_list.concat(payload.list); state.total_count = payload.total_count },
  setUserUpdateInMentorList(state, payload) {
    let i = state.mentor_list.map(item => item.slug).indexOf(payload.slug);
    state.mentor_list[i].get_full_name=payload.full_name;
  },
  setUserPhotoInMentorList(state, payload) { state.mentor_list[state.mentor_list.map(item => item.slug).indexOf(payload.slug)].photo_url=payload.photo_url },
  setUserActivityInMentorList(state, payload) { state.mentor_list[state.mentor_list.map(item => item.slug).indexOf(payload.slug)].is_active=payload.is_active },
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
